import { FaThermometerHalf, FaCloudRain, FaSnowflake } from "react-icons/fa";
import { WiHumidity, WiBarometer, WiHot, WiFlood, WiStrongWind } from "react-icons/wi";

const typeDetails = {
	TYPE_TERM: {
		pos: 1,
		label: "Temperatura",
		sensor: "Termometro",
		unit: "°C",
		short: null,
		icon: FaThermometerHalf,
		getColor: (value) => {
			if (value <= -10) return "#0320fc"; // blu
			if (value <= 0) return "#007bff"; // Blu chiaro
			if (value <= 10) return "#00b398"; // verde acqua
			if (value <= 20) return "#b1cc00"; // Giallo
			if (value <= 30) return "#b1cc00"; // Arancione
			if (value <= 40) return "#cc0000"; // Arancione
			return "#e74c3c"; // Rosso
		},
	},
	TYPE_IGRO: {
		pos: 2,
		label: "Umidità",
		sensor: "Idrometro",
		unit: "%",
		short: null,
		icon: WiHumidity,
		getColor: (value) => {
			if (value < 20) return "#e74c3c"; // Rosso
			if (value < 40) return "#ffa500"; // Arancione
			if (value < 60) return "#f1c40f"; // Giallo
			if (value < 80) return "#2ecc71"; // Verde
			return "#3498db"; // Blu
		},
	},
	TYPE_IDRO: {
		pos: 10,
		label: "Livello dell'acqua",
		sensor: "Idrometro",
		unit: "m",
		short: null,
		icon: WiFlood,
		getColor: (value, pre, all, dan) => {
			// if (value <= 0) return "#555"; // Grigio
			if (!pre || !all || !dan) return "#555"; // Grigio
			if (value < pre) return "#2ecc71"; // Verde
			if (value < all) return "#f1c40f"; // Giallo
			if (value < dan) return "#d16900"; // Arancione
			return "#e74c3c"; // Rosso
		},
	},
	TYPE_ANEM_wind: {
		pos: 11,
		label: "Vento",
		sensor: "Anemometro",
		unit: "km/h",
		short: null,
		icon: WiStrongWind,
		useCardinal: true,
		getColor: (value) => {
			if (value === "0") return "#999"; // Grigio
			if (value < 5) return "#2ecc71"; // Verde
			if (value < 15) return "#f1c40f"; // Giallo
			if (value < 30) return "#ffa500"; // Arancione
			if (value < 50) return "#e74c3c"; // Rosso
			return "#800000"; // Rosso scuro
		},
	},
	TYPE_BARO: {
		pos: 12,
		label: "Pressione",
		sensor: "Barometro",
		unit: "hPa",
		short: null,
		icon: WiBarometer,
		getColor: (value) => {
			if (value < 950) return "#800000"; // Rosso scuro
			if (value < 1000) return "#e74c3c"; // Rosso
			if (value < 1020) return "#f1c40f"; // Giallo
			if (value < 1030) return "#2ecc71"; // Verde
			return "#3498db"; // Blu
		},
	},
	TYPE_PIRA: {
		pos: 13,
		label: "Radiazione solare",
		sensor: "Solarimetro",
		unit: "W/m²",
		short: null,
		icon: WiHot,
		getColor: (value) => {
			if (value === "0") return "#999"; // Grigio
			if (value < 100) return "#87cefa"; // Blu chiaro
			if (value < 300) return "#2ecc71"; // Verde
			if (value < 600) return "#f1c40f"; // Giallo
			if (value < 900) return "#ffa500"; // Arancione
			return "#e74c3c"; // Rosso
		},
	},
	TYPE_NIVO: {
		pos: 14,
		label: "Neve",
		sensor: "Nivometro",
		unit: "cm",
		short: null,
		icon: FaSnowflake,
		getColor: (value) => {
			if (value === "0") return "#999"; // Grigio
			if (value < 20) return "#87cefa"; // Blu chiaro
			if (value < 50) return "#3498db"; // Blu
			if (value < 100) return "#1e90ff"; // Azzurro
			return "#000080"; // Blu scuro
		},
	},
	TYPE_PLUVIO_2: {
		pos: 3,
		label: "Pioggia (30m)",
		sensor: "Pluviometro 30m",
		unit: "mm",
		short: "30m",
		icon: FaCloudRain,
		getColor: (value) => {
			if (value === "0.0") return "#999"; // Grigio
			if (value <= 5) return "#2ecc71"; // Verde chiaro
			if (value <= 10) return "#3498db"; // Blu
			if (value <= 20) return "#9b59b6"; // Viola
			return "#e74c3c"; // Rosso
		},
	},
	TYPE_PLUVIO_1: {
		pos: 4,
		label: "Pioggia (1h)",
		sensor: "Pluviometro 1h",
		unit: "mm",
		short: "1h",
		icon: FaCloudRain,
		getColor: (value) => {
			if (value === "0.0") return "#999"; // Grigio
			if (value <= 5) return "#2ecc71"; // Verde chiaro
			if (value <= 10) return "#3498db"; // Blu
			if (value <= 20) return "#9b59b6"; // Viola
			return "#e74c3c"; // Rosso
		},
	},
	TYPE_PLUVIO_3: {
		pos: 5,
		label: "Pioggia (3h)",
		sensor: "Pluviometro 3h",
		unit: "mm",
		short: "3h",
		icon: FaCloudRain,
		getColor: (value) => {
			if (value === "0.0") return "#999"; // Grigio
			if (value <= 5) return "#2ecc71"; // Verde chiaro
			if (value <= 10) return "#3498db"; // Blu
			if (value <= 20) return "#9b59b6"; // Viola
			return "#e74c3c"; // Rosso
		},
	},
	TYPE_PLUVIO_6: {
		pos: 6,
		label: "Pioggia (6h)",
		sensor: "Pluviometro 6h",
		unit: "mm",
		short: "6h",
		icon: FaCloudRain,
		getColor: (value) => {
			if (value === "0.0") return "#999"; // Grigio
			if (value <= 5) return "#2ecc71"; // Verde chiaro
			if (value <= 10) return "#3498db"; // Blu
			if (value <= 20) return "#9b59b6"; // Viola
			return "#e74c3c"; // Rosso
		},
	},
	TYPE_PLUVIO_12: {
		pos: 7,
		label: "Pioggia (12h)",
		sensor: "Pluviometro 12h",
		unit: "mm",
		short: "12h",
		icon: FaCloudRain,
		getColor: (value) => {
			if (value === "0.0") return "#999"; // Grigio
			if (value <= 5) return "#2ecc71"; // Verde chiaro
			if (value <= 10) return "#3498db"; // Blu
			if (value <= 20) return "#9b59b6"; // Viola
			return "#e74c3c"; // Rosso
		},
	},
	TYPE_PLUVIO_24: {
		pos: 8,
		label: "Pioggia (24h)",
		sensor: "Pluviometro 24h",
		unit: "mm",
		short: "24h",
		icon: FaCloudRain,
		getColor: (value) => {
			if (value === "0.0") return "#999"; // Grigio
			if (value <= 5) return "#2ecc71"; // Verde chiaro
			if (value <= 10) return "#3498db"; // Blu
			if (value <= 20) return "#9b59b6"; // Viola
			return "#e74c3c"; // Rosso
		},
	},
};

const getCardinalDirection = (degrees) => {
	if (degrees === "nd") return "";

	const directions = [
		"Nord",
		"Nord-Est",
		"Est",
		"Sud-Est",
		"Sud",
		"Sud-Ovest",
		"Ovest",
		"Nord-Ovest",
	];
	const index = Math.round(degrees / 45) % 8;
	return directions[index];
};
const getCardinalDirectionShort = (degrees) => {
	if (degrees === "nd") return "";
	const directions = ["N", "NE", "E", "SE", "S", "SO", "O", "NO"];
	const index = Math.round(degrees / 45) % 8;
	return directions[index];
};

const groupSensorsByPosition = (sensors) => {
	const grouped = {};

	sensors.forEach((sensor) => {
		const { latitude, longitude } = sensor;
		const key = `${latitude},${longitude}`;

		if (!grouped[key]) {
			grouped[key] = {
				position: [latitude, longitude],
				sensors: [],
			};
		}

		grouped[key].sensors.push(sensor);
	});

	return Object.values(grouped);
};

export { typeDetails, getCardinalDirection, getCardinalDirectionShort, groupSensorsByPosition };
